"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = /*#__PURE__*/ (0, vue_2.createElementVNode)("b", null, "marso", -1);
const _hoisted_2 = { class: "thankyou-title" };
const _hoisted_3 = { class: "thankyou-text" };
const Banner_vue_1 = __importDefault(require("../../../components/frontend/Banner.vue"));
//import { useRouter } from "vue-router";
//const router = useRouter();
//router.push("/admin"); // átírányít folyamatosan az admin loginra ha ide érkezne be van valaki
exports.default = (0, vue_1.defineComponent)({
    __name: 'Thankyou',
    setup(__props) {
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createVNode)(Banner_vue_1.default, { "background-image": "frontend/home_banner.png" }, {
                    bannerText: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createTextVNode)(" CLICK'N'FIt ")
                    ]),
                    bottomText: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createTextVNode)(" powered by "),
                        _hoisted_1
                    ]),
                    _: 1
                }),
                (0, vue_2.createElementVNode)("h1", _hoisted_2, (0, vue_2.toDisplayString)(_ctx.$trans("thankyou_title", "THANK YOU FOR YOUR BOOKING!", "frontend_contact_block")), 1),
                (0, vue_2.createElementVNode)("div", _hoisted_3, (0, vue_2.toDisplayString)(_ctx.$trans("thankyou_text", 
                // eslint-disable-next-line max-len
                "You will soon receive an e-mail containing the details of your reservation, a service address, the exact time. If for some reason you cannot show up for the booked appointment, then in the letter you will find a link through which you can cancel the your reservation.", "frontend_contact_block")), 1)
            ], 64));
        };
    }
});
